import { render } from "./ExternalApi.vue?vue&type=template&id=48b6bd82"
import script from "./ExternalApi.vue?vue&type=script&lang=js"
export * from "./ExternalApi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__